<c-card *transloco="let t">
  <c-card-body *ngIf="account" class="px-2">

          <c-row>
            <c-col md="12">
                <h1>{{ t('Your OK Alone Settings') }}</h1>
              <p>
                  {{ t('Hello, here are your OK Alone company-wide settings.', { user: account.company_name}) }}
              </p>
              <p>
                  {{ t('If you need to make any more changes, please contact OK Alone at') }} <a href="mailto:customer.support@ok-alone.com" target="_new">customer.support&#64;ok-alone.com</a>.
              </p>

            </c-col>
          </c-row>


          <c-row class="justify-content-left">
            <div class="col-md-6">
                  <form [formGroup]="formGroup" cForm (ngSubmit)="submitForm()" class="info-form">

              <ng-container *ngIf="okService.hasFeature('flex_delay')">

                <div class="card mb-2">
                  <div class="card-header">
                    {{ t('Flexible Alert Delay / Grace Period') }}
                  </div>
                  <div class="card-body">
                    {{ t('Set an alternate alert grace period period for High Risk Check-ins and Worker Down.') }}


                    <div class="row mb-3">
                      <label class="col-4 col-form-label text-end">{{ t('Grace Period') }}</label>
                      <div class="col-8">
                        <ng-select
                        [items]="alert_delays"
                        bindLabel="name"
                        bindValue="value"
                        formControlName="alert_delay"
                        placeholder="{{ t('Grace Period') }}"
                        >
                        </ng-select>
                        <button type="button" class="btn btn-link btn-sm popover-info" data-bs-trigger="hover" data-bs-toggle="popover" data-placement="top" [attr.data-bs-content]="t('Grace Period adds an extra time between when a missed check in is triggered and when your monitors are alerted to the issue. This allows for a grace period for missed check ins. This is a global setting and affects all workers.')"><i class="fa-solid fa-circle-info text-secondary" ></i></button>
                        <div *ngIf="submitted && f['alert_delay'].errors" class="invalid-feedback">
                          {{ t('Grace Period') }}
                        </div>
                      </div>
                    </div>
                    
                    @if(okService.settings.arc_on) {
                      <p class="alert alert-warning"><i class="fa-solid fa-triangle-exclamation text-danger"></i> {{ t('Grace Period cannot be changed as this account is using our Safety Monitoring Center.') }}</p>
                    }

                    <div class="row mb-3">
                      <label class="col-4 col-form-label text-end">{{ t('Grace Period - High Risk') }}</label>
                      <div class="col-8">
                        <ng-select
                        [items]="flex_alert_delays"
                        bindLabel="name"
                        bindValue="value"
                        formControlName="alert_delay_highrisk"
                        placeholder="{{ t('None') }}"
                        >
                        </ng-select>
                        <button type="button" class="btn btn-link btn-sm popover-info" data-bs-trigger="hover" data-bs-toggle="popover" data-placement="top" [attr.data-bs-content]="t('Grace Period adds an extra time between when a missed check in is triggered and when your monitors are alerted to the issue. This allows for a grace period for missed check ins. This is a global setting and affects all workers.')"><i class="fa-solid fa-circle-info text-secondary" ></i></button>
                        <div *ngIf="submitted && f['alert_delay_highrisk'].errors" class="invalid-feedback">
                          {{ t('Grace Period') }}
                        </div>
                      </div>
                    </div>

                    <div class="row mb-3">
                      <label class="col-4 col-form-label text-end">{{ t('Grace Period - Worker Down') }}</label>
                      <div class="col-8">
                        <ng-select
                        [items]="flex_alert_delays"
                        bindLabel="name"
                        bindValue="value"
                        formControlName="alert_delay_mandown"
                        placeholder="{{ t('None') }}"
                        >
                        </ng-select>
                        <button type="button" class="btn btn-link btn-sm popover-info" data-bs-trigger="hover" data-bs-toggle="popover" data-placement="top" [attr.data-bs-content]="t('Grace Period adds an extra time between when a missed check in is triggered and when your monitors are alerted to the issue. This allows for a grace period for missed check ins. This is a global setting and affects all workers.')"><i class="fa-solid fa-circle-info text-secondary" ></i></button>
                        <div *ngIf="submitted && f['alert_delay_mandown'].errors" class="invalid-feedback">
                          {{ t('Grace Period - Worker Down') }}
                        </div>
                      </div>
                    </div>

                    <ng-container *ngIf="okService.hasFeature('fall_detection')">

                    <div class="row mb-3">
                      <label class="col-4 col-form-label text-end">{{ t('Grace Period - Fall Detection') }}</label>
                      <div class="col-8">
                        <ng-select
                        [items]="flex_fall_alert_delays"
                        bindLabel="name"
                        bindValue="value"
                        formControlName="alert_delay_fall"
                        placeholder="{{ t('None') }}"
                        >
                        </ng-select>
                        <button type="button" class="btn btn-link btn-sm popover-info" data-bs-trigger="hover" data-bs-toggle="popover" data-placement="top" [attr.data-bs-content]="t('Grace Period adds an extra time between when a missed check in is triggered and when your monitors are alerted to the issue. This allows for a grace period for missed check ins. This is a global setting and affects all workers.')"><i class="fa-solid fa-circle-info text-secondary" ></i></button>
                        <div *ngIf="submitted && f['alert_delay_fall'].errors" class="invalid-feedback">
                          {{ t('Grace Period - Fall Detection') }}
                        </div>
                      </div>
                    </div>

                  </ng-container>
                    

                    <c-row>
                      <c-col xs="6" class="mt-3">
                        <button cButton class="px-4 text-white btn-info" type="submit">
                          <i class="fa-solid fa-check"></i>  {{ t('Update') }}
                        </button>
                      </c-col>
                    </c-row>
                  </div>
                </div>


              </ng-container>



                <div class="card">
                  <div class="card-header">
                    {{ t('Company Settings') }}
                  </div>
                  <div class="card-body">

                      <ng-container *ngIf="!okService.hasFeature('flex_delay')">

                        <div class="row mb-3">
                          <label class="col-4 col-form-label text-end">{{ t('Grace Period') }}</label>
                          <div class="col-8">
                            <ng-select
                            [items]="alert_delays"
                            bindLabel="name"
                            bindValue="value"
                            formControlName="alert_delay"
                            placeholder="{{ t('Grace Period') }}"
                            >
                            </ng-select>
                            <button type="button" class="btn btn-link btn-sm popover-info" data-bs-trigger="hover" data-bs-toggle="popover" data-placement="top" [attr.data-bs-content]="t('Grace Period adds an extra time between when a missed check in is triggered and when your monitors are alerted to the issue. This allows for a grace period for missed check ins. This is a global setting and affects all workers.')"><i class="fa-solid fa-circle-info text-secondary" ></i></button>
                            <div *ngIf="submitted && f['alert_delay'].errors" class="invalid-feedback">
                              {{ t('Grace Period') }}
                            </div>
                          </div>
                        </div>

                        @if(okService.settings.arc_on) {
                          <p class="alert alert-warning"><i class="fa-solid fa-triangle-exclamation text-danger"></i> {{ t('Grace Period cannot be changed as this account is using our Safety Monitoring Center.') }}</p>
                        }

                    </ng-container>

                      <div class="row mb-3">
                        <label for="message_alert" class="col-4 col-form-label text-end">{{ t('Send App Messages to Monitors') }}</label>
                        <div class="col-8">

                          <select  class="form-control col-sm-4" id="message_alert" name="message_alert"  formControlName="message_alert">
                            <option [ngValue]="true">{{ t('Yes') }}</option>
                            <option [ngValue]="false">{{ t('No') }}</option>
                          </select>
                          <button type="button" class="btn btn-link btn-sm popover-info" data-bs-trigger="hover" data-bs-toggle="popover" data-placement="top" [attr.data-bs-content]="t('Pass along all messages sent by workers to the system to be passed along to their respective monitors.')"><i class="fa-solid fa-circle-info text-secondary" ></i></button>

                        </div>
                      </div>

                      <ng-container *ngIf="okService.hasFeature('auto_end_shift')">

                        <div class="row mb-3">
                          <label class="col-4 col-form-label text-end">{{ t('Auto End Shift Time') }}</label>
                          <div class="col-8">
                            <ng-select
                            [items]="day_hours"
                            bindLabel="name"
                            bindValue="value"
                            formControlName="auto_end_shift"
                            placeholder="{{ t('None') }}"
                            >
                            </ng-select>
                            <button type="button" class="btn btn-link btn-sm popover-info" data-bs-trigger="hover" data-bs-toggle="popover" data-placement="top" [attr.data-bs-content]="t('Automatically end all worker shifts at a certain time. This affects all workers and should only be used if worker safety is already accounted for at the end of every shift.')"><i class="fa-solid fa-circle-info text-secondary" ></i></button>
                            <div *ngIf="submitted && f['auto_end_shift'].errors" class="invalid-feedback">
                              {{ t('Auto End Shift Time') }}
                            </div>
                          </div>
                        </div>

                        <div class="row mb-3" *ngIf="formGroup.value.auto_end_shift">
                          <label class="col-4 col-form-label text-end">{{ t('Auto End SMS') }}</label>
                          <div class="col-8">
                            <select  class="form-control col-sm-4" id="auto_end_sms" name="auto_end_sms"  formControlName="auto_end_sms">
                              <option [ngValue]="true" *ngIf="okService.billing.plan.comms_active">{{ t('Yes') }}</option>
                              <option [ngValue]="false">{{ t('No') }}</option>
                            </select>
                            <button type="button" class="btn btn-link btn-sm popover-info" data-bs-trigger="hover" data-bs-toggle="popover" data-placement="top" [attr.data-bs-content]="t('Send an SMS to workers when their shift is going to end automatically.')"><i class="fa-solid fa-circle-info text-secondary" ></i></button>
                            <div *ngIf="submitted && f['auto_end_sms'].errors" class="invalid-feedback">
                              {{ t('Auto End SMS') }}
                            </div>
                            <div class="alert alert-warning mt-1" role="alert" *ngIf="!okService.billing.plan.comms_active">
                              @if(okService.billing.plan.account_type == "Pricing2024"){
                                <i class="fa-solid fa-triangle-exclamation text-danger"></i> {{ t('The Automated Plan is required to send worker SMS notifications.') }}
                              }@else{
                                <i class="fa-solid fa-triangle-exclamation text-danger"></i> {{ t('The Comms Plan is required to send worker SMS notifications.') }}
                              }
                            </div>
                          </div>

                        </div>
                      </ng-container>

                      <div class="row mb-3" *ngIf="okService.billing.plan.comms_active">
                        <label class="col-4 col-form-label text-end">{{ t('SMS Status Confirmation') }}</label>
                        <div class="col-8">
                          <select  class="form-control col-sm-4" id="status_reply" name="status_reply"  formControlName="status_reply">
                            <option [ngValue]="true" *ngIf="okService.billing.plan.comms_active">{{ t('Yes') }}</option>
                            <option [ngValue]="false">{{ t('No') }}</option>
                          </select>
                          <button type="button" class="btn btn-link btn-sm popover-info" data-bs-trigger="hover" data-bs-toggle="popover" data-placement="top" [attr.data-bs-content]="t('Send a confirmation of the current status of a worker after an SMS action.')"><i class="fa-solid fa-circle-info text-secondary" ></i></button>
                          <div *ngIf="submitted && f['status_reply'].errors" class="invalid-feedback">
                            {{ t('SMS Status Confirmation') }}
                          </div>
                          <div class="alert alert-warning mt-1" role="alert" *ngIf="!okService.billing.plan.comms_active">
                            <i class="fa-solid fa-triangle-exclamation text-danger"></i> {{ t('The Comms Plan is required to send worker SMS notifications.') }}
                          </div>
                        </div>

                      </div>

                      <div class="row mb-3" *ngIf="okService.billing.plan.comms_active">
                        <label class="col-4 col-form-label text-end">{{ t('Use Worker Alt Phone Number for SMS') }}</label>
                        <div class="col-8">
                          <select class="form-control col-sm-4" id="sms_reminder_alt" name="sms_reminder_alt" formControlName="sms_reminder_alt">
                            <option [ngValue]="true">{{ t('Yes') }}</option>
                            <option [ngValue]="false">{{ t('No') }}</option>
                          </select>
                          <button type="button" class="btn btn-link btn-sm popover-info" data-bs-trigger="hover" data-bs-toggle="popover" data-placement="top" [attr.data-bs-content]="t('Also use the worker\'s alt phone number for SMS notifications.')"><i class="fa-solid fa-circle-info text-secondary"></i></button>
                          <div *ngIf="submitted && f['sms_reminder_alt'].errors" class="invalid-feedback">
                            {{ t('SMS Alt Phone Number') }}
                          </div>
                        </div>
                      </div>

                      <ng-container *ngIf="okService.hasFeature('fa2')">

                        <div class="row mb-3" *ngIf="okService.billing.plan.comms_active">
                          <label class="col-4 col-form-label text-end">{{ t('Monitor Multi-Factor Authentication') }}</label>
                          <div class="col-8">
                            <select  class="form-control col-sm-4" id="fa2" name="fa2"  formControlName="fa2">
                              <option [ngValue]="true" *ngIf="okService.billing.plan.comms_active">{{ t('Yes') }}</option>
                              <option [ngValue]="false">{{ t('No') }}</option>
                            </select>
                            <button type="button" class="btn btn-link btn-sm popover-info" data-bs-trigger="hover" data-bs-toggle="popover" data-placement="top" [attr.data-bs-content]="t('Enable Multi-Factor Authentication for monitors. Monitors receive a one-time passcode by SMS or email to verify their identity.')"><i class="fa-solid fa-circle-info text-secondary" ></i></button>
                            <div *ngIf="submitted && f['fa2'].errors" class="invalid-feedback">
                              {{ t('Monitor Multi-Factor Authentication') }}
                            </div>
                            <div class="alert alert-warning mt-1" role="alert" *ngIf="!okService.billing.plan.comms_active">
                              <i class="fa-solid fa-triangle-exclamation text-danger"></i> {{ t('The Comms Plan is required to send one-time passcodes to monitors by SMS.') }}
                            </div>
                          </div>

                        </div>


                      </ng-container>


                      @if(okService.isFromAdmin()){

                        <ng-container *ngIf="okService.hasFeature('app_mfa')">

                          <div class="row mb-3" *ngIf="okService.billing.plan.comms_active">
                            <label class="col-4 col-form-label text-end">{{ t('App Multi-Factor Authentication') }}</label>
                            <div class="col-8">
                              <select  class="form-control col-sm-4" id="app_mfa" name="app_mfa"  formControlName="app_mfa">
                                <option [ngValue]="true">{{ t('Yes') }}</option>
                                <option [ngValue]="false">{{ t('No') }}</option>
                              </select>
                              <button type="button" class="btn btn-link btn-sm popover-info" data-bs-trigger="hover" data-bs-toggle="popover" data-placement="top" [attr.data-bs-content]="t('Enable Multi-Factor Authentication for the app. Workers receive a one-time passcode by SMS to verify their identity.')"><i class="fa-solid fa-circle-info text-secondary" ></i></button>
                            </div>
                          </div>

                        </ng-container>

                      }

                      <div class="row mb-3">
                        <label class="col-4 col-form-label text-end">{{ t('Timezone') }}</label>
                        <div class="col-8">
                          <ng-select
                          [items]="timezoneListArray"
                          bindLabel="name"
                          bindValue="tzCode"
                          formControlName="timezone"
                          placeholder="{{ t('Timezone') }}"
                          >
                          </ng-select>
                          <button type="button" class="btn btn-link btn-sm popover-info" data-bs-trigger="hover" data-bs-toggle="popover" data-placement="top" [attr.data-bs-content]="t('Change your company timezone.')"><i class="fa-solid fa-circle-info text-secondary" ></i></button>
                          <div *ngIf="submitted && f['timezone'].errors" class="invalid-feedback">
                            {{ t('Timezone Required') }}
                          </div>
                        </div>
                      </div>

                      <div class="row mb-3" *ngIf="okService.isOkAloneAdmin() && okService.settings.arc_on">
                        <label class="col-4 col-form-label text-end">{{ t('Safety Monitoring Center Region') }}</label>
                        <div class="col-8">
                          <ng-select
                          [items]="regionsArray"
                          bindLabel="name"
                          bindValue="code"
                          formControlName="arc_region"
                          placeholder="{{ t('Region') }}"
                          >
                          </ng-select>
                          <button type="button" class="btn btn-link btn-sm popover-info" data-bs-trigger="hover" data-bs-toggle="popover" data-placement="top" [attr.data-bs-content]="t('Choose you region for our Safety Monitoring Center.')"><i class="fa-solid fa-circle-info text-secondary" ></i></button>
                          <div *ngIf="submitted && f['timezone'].errors" class="invalid-feedback">
                            {{ t('Safety Monitoring Center Region Required') }}
                          </div>
                        </div>
                      </div>

                      <ng-container *ngIf="okService.hasFeature('force_password_reset')">
                      <div class="row mb-3">
                        <label class="col-4 col-form-label text-end">{{ t('Force Password Reset') }}</label>
                        <div class="col-8">
                          <select  class="form-control col-sm-4" id="password_change_on" name="password_change_on"  formControlName="password_change_on">
                            <option [ngValue]="true">{{ t('Yes') }}</option>
                            <option [ngValue]="false">{{ t('No') }}</option>
                          </select>
                          <button type="button" class="btn btn-link btn-sm popover-info" data-bs-trigger="hover" data-bs-toggle="popover" data-placement="top" [attr.data-bs-content]="t('Force monitors to change their password after a certain amount of time has passed')"><i class="fa-solid fa-circle-info text-secondary" ></i></button>
                          <div *ngIf="submitted && f['password_change_on'].errors" class="invalid-feedback">
                            {{ t('Force Password Reset') }}
                          </div>
                        </div>

                      </div>

                      <div class="row mb-3" *ngIf="formGroup.value.password_change_on">
                        <label class="col-4 col-form-label text-end">{{ t('Change Password Every:') }}</label>
                        <div class="col-8">
                          <ng-select
                          [items]="change_days"
                          bindLabel="name"
                          bindValue="value"
                          formControlName="password_change_days"
                          placeholder="{{ t('None') }}"
                          >
                          </ng-select>
                          <button type="button" class="btn btn-link btn-sm popover-info" data-bs-trigger="hover" data-bs-toggle="popover" data-placement="top" [attr.data-bs-content]="t('Have monitors change their password by the chosen amount of months.')"><i class="fa-solid fa-circle-info text-secondary" ></i></button>
                          <div *ngIf="submitted && f['password_change_days'].errors" class="invalid-feedback">
                            {{ t('Change Password Every:') }}
                          </div>
                        </div>
                      </div>
                      </ng-container>
                      <div class="row mb-3" *ngIf="okService.isGeotab()">
                        <label for="assign_vehicle" class="col-4 col-form-label text-end">{{ t('Auto Assign Vehicle') }}</label>
                        <div class="col-8">

                          <select  class="form-control col-sm-4" id="assign_vehicle" name="assign_vehicle"  formControlName="assign_vehicle">
                            <option [ngValue]="true">{{ t('Yes') }}</option>
                            <option [ngValue]="false">{{ t('No') }}</option>
                          </select>
                          <button type="button" class="btn btn-link btn-sm popover-info" data-bs-trigger="hover" data-bs-toggle="popover" data-placement="top" [attr.data-bs-content]="t('Use the vehicle assignment in Geotab to automatically update the driver vehicle when they are imported to the system or start a shift.')"><i class="fa-solid fa-circle-info text-secondary" ></i></button>

                        </div>
                      </div>

                      <c-row>
                        <c-col xs="6" class="mt-3">
                          <button cButton class="px-4 text-white btn-info" type="submit">
                            <i class="fa-solid fa-check"></i>  {{ t('Update') }}
                          </button>
                        </c-col>
                      </c-row>

                    </div>
                  </div>
                  </form>

            </div>
            <div class="col-md-6">

              <ng-container *ngIf="okService.hasFeature('two_way_audio')">

                <div class="card mb-3">
                  <div class="card-header">
                    {{ t('Alert Audio') }}
                  </div>
                  <div class="card-body">
                    <p>{{ t('Alert Audio is a feature which starts a call between the worker's app and a monitor or SMC when a help alert is triggered.') }}</p>
                    <form *ngIf="twoWayAudioGroup" [formGroup]="twoWayAudioGroup" cForm (ngSubmit)="submitTwoWayAudioForm()" class="info-form">

                      <div class="row mb-3">
                        <label class="col-4 col-form-label text-end">{{ t('Alert Audio Enabled') }}</label>
                        <div class="col-8">
                          <select  class="form-control col-sm-4" id="two_way_audio_enabled" name="two_way_audio_enabled"  formControlName="two_way_audio_enabled">
                            <option [ngValue]="true">{{ t('Yes') }}</option>
                            <option [ngValue]="false">{{ t('No') }}</option>
                          </select>
                        </div>
                      </div>

                      @if(okService.settings.arc_on){

                        <div class="row mb-3">
                          <label class="col-4 col-form-label text-end">{{ t('Alert Audio Enabled for Safety Monitoring Center') }}</label>
                          <div class="col-8">
                            <select  class="form-control col-sm-4" id="two_way_audio_smc" name="two_way_audio_smc"  formControlName="two_way_audio_smc">
                              <option [ngValue]="true">{{ t('Yes') }}</option>
                              <option [ngValue]="false">{{ t('No') }}</option>
                            </select>
                          </div>
                        </div>

                      }

                      <div class="row mb-3">
                        <label class="col-4 col-form-label text-end">{{ t('Alert Audio Phone Number') }}</label>
                        <div class="col-8">
                          <input class="form-control" type="text" id="two_way_audio_number" name="two_way_audio_number"  formControlName="two_way_audio_number">
                        </div>
                      </div>

                      @if(okService.settings.arc_on){
                        <div class="alert alert-warning " role="alert">
                          {{ t('Alert Audio phone number is only used where there is no Safety Monitoring Center.') }}
                        </div>
                      }

                      <div class="row mb-3">
                        <label class="col-4 col-form-label text-end">{{ t('Enable Alert Audio Audio on Fall') }}</label>
                        <div class="col-8">
                          <select  class="form-control col-sm-4" id="two_way_audio_on_fall" name="two_way_audio_on_fall"  formControlName="two_way_audio_on_fall">
                            <option [ngValue]="true">{{ t('Yes') }}</option>
                            <option [ngValue]="false">{{ t('No') }}</option>
                          </select>
                        </div>
                      </div>
                      <c-row>
                        <c-col xs="6" class="mt-3">
                          <button cButton class="px-4 text-white btn-info" type="submit">
                            <i class="fa-solid fa-check"></i>  {{ t('Update') }}
                          </button>
                        </c-col>
                      </c-row>
                    </form>
                  </div>
                </div>

              </ng-container>

              <ng-container *ngIf="okService.hasFeature('action_notices')">
                <div class="card">
                  <div class="card-header">
                    <a href="https://okalone.zendesk.com/hc/en-gb/articles/35909033970577-Action-Notices-Keeping-Monitors-Informed-Without-Overload" class="btn btn-primary btn-sm float-end" target="_new"><i class="fa fa-question-circle" aria-hidden="true"></i> {{ t('Help') }}</a>
                    {{ t('Action Notices') }}
                  </div>
                  <div class="card-body">
                    <p>{{ t('Action Notices are informational notifications sent to designated monitors when non urgent actions are performed.') }} </p>

                    <form *ngIf="noticesGroup" [formGroup]="noticesGroup" cForm (ngSubmit)="submitNoticesForm()" class="info-form">

                      <div class="row mb-3">
                        <label for="message_alert" class="col-4 col-form-label text-end">{{ t('Use Action Notices') }}</label>
                        <div class="col-8">

                          <select  class="form-control col-sm-4" id="notices_on" name="notices_on"  formControlName="notices_on">
                            <option [ngValue]="true">{{ t('Yes') }}</option>
                            <option [ngValue]="false">{{ t('No') }}</option>
                          </select>
                          <button type="button" class="btn btn-link btn-sm popover-info" data-bs-trigger="hover" data-bs-toggle="popover" data-placement="top" [attr.data-bs-content]="t('Turn on Alert Notices for your company')"><i class="fa-solid fa-circle-info text-secondary" ></i></button>

                        </div>
                      </div>

                      <ng-container *ngIf="noticesGroup.value.notices_on">


                      <div class="row mb-3">
                        <label class="col-4 col-form-label text-end">{{ t('Contact Method') }}</label>
                        <div class="col-8">
                          <ng-select
                          [items]="notices_contact"
                          bindLabel="name"
                          bindValue="name"
                          [multiple]="true"
                          formControlName="notices_contact"
                          placeholder="{{ t('Notice Contact Method') }}"
                          >
                          </ng-select>
                          <button type="button" class="btn btn-link btn-sm popover-info" data-bs-trigger="hover" data-bs-toggle="popover" data-placement="top" [attr.data-bs-content]="t('How will monitors be contacted when there is an Action Notice')"><i class="fa-solid fa-circle-info text-secondary" ></i></button>
                        </div>
                      </div>


                      <div class="form-group row mb-2">
                        <label class="col-4 col-form-label text-start text-sm-end">{{ t('Action Notices:') }}</label>
                        <div class="col-8">

                          <div class="row">
                            <div class="col-10">
                              <input class="form-check-input" type="checkbox" id="start_shift" name="start_shift"  formControlName="start_shift">
                              <label class="form-check-label" for="start_shift">
                                &nbsp; &nbsp;{{ t('Start Shift') }}
                              </label>
                            </div>
                          </div>

                          <div class="row">
                            <div class="col-10">
                              <input class="form-check-input" type="checkbox" id="end_shift" name="end_shift"  formControlName="end_shift">
                              <label class="form-check-label" for="end_shift">
                                &nbsp; &nbsp;{{ t('End Shift') }}
                              </label>
                            </div>
                          </div>

                          <!-- <div class="row">
                            <div class="col-10">
                              <input class="form-check-input" type="checkbox" id="check_in" name="check_in"  formControlName="check_in">
                              <label class="form-check-label" for="check_in">
                                &nbsp; &nbsp;{{ t('Check-In') }}
                              </label>
                            </div>
                          </div>

                          <div class="row">
                            <div class="col-10">
                              <input class="form-check-input" type="checkbox" id="overdue" name="overdue"  formControlName="overdue">
                              <label class="form-check-label" for="overdue">
                                &nbsp; &nbsp;{{ t('Overdue') }}
                              </label>
                            </div>
                          </div> -->
                          <div class="row">
                            <div class="col-10">
                              <input class="form-check-input" type="checkbox" id="set_high_risk" name="set_high_risk"  formControlName="set_high_risk">
                              <label class="form-check-label" for="set_high_risk">
                                &nbsp; &nbsp;{{ t('High Risk Setup') }}
                              </label>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-10">
                              <input class="form-check-input" type="checkbox" id="change_man_down" name="change_man_down"  formControlName="change_man_down">
                              <label class="form-check-label" for="change_man_down">
                                &nbsp; &nbsp;{{ t('Man/Worker Down Changed') }}
                              </label>
                            </div>
                          </div>
                          <!-- <div class="row">
                            <div class="col-10">
                              <input class="form-check-input" type="checkbox" id="alert_acknowledged" name="alert_acknowledged"  formControlName="alert_acknowledged">
                              <label class="form-check-label" for="alert_acknowledged">
                                &nbsp; &nbsp;{{ t('Alert Acknowledged') }}
                              </label>
                            </div>
                          </div>
                          <div class="row" *ngIf="okService.hasFeature('alert_loops')">
                            <div class="col-10">
                              <input class="form-check-input" type="checkbox" id="alert_accepted" name="alert_accepted"  formControlName="alert_accepted">
                              <label class="form-check-label" for="">
                                &nbsp; &nbsp;{{ t('Alert Accepted') }}
                              </label>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-10">
                              <input class="form-check-input" type="checkbox" id="alert_resolved" name="alert_resolved"  formControlName="alert_resolved">
                              <label class="form-check-label" for="alert_resolved">
                                &nbsp; &nbsp;{{ t('Alert Resolved') }}
                              </label>
                            </div>
                          </div> -->

                        </div>
                      </div>


                      </ng-container>


                      <c-row>
                        <c-col xs="12" class="mt-3">

                          <div class="alert alert-warning alert-dismissible fade show" role="alert" *ngIf="!okService.isDismissed('action_notices_info')">
                            {{ t('We recommend using Action Notices sparingly, as too many notices may overwhelm the monitor and distract from real alerts.') }}
                            <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close" (click)="okService.doDismiss('action_notices_info')"></button>
                          </div>
                          <button cButton class="px-4 text-white btn-info" type="submit">
                            <i class="fa-solid fa-check"></i>  {{ t('Update Action Notices') }}
                          </button>
                        </c-col>
                      </c-row>

                      </form>


                  </div>
                </div>
              </ng-container>
            </div>
          </c-row>



  </c-card-body>
</c-card>


